import React, { useEffect, useState } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import { listSupervisedBanks } from '../../api/supervisor';
import {
  createSubSupervisor, deleteSubSupervisor, listSubSupervisors, updateSubSupervisor,
} from '../../api/supervisor';
import './SupervisorSubSupervisorsPage.css';

const emptyForm = { name: '', username: '', password: '', banks: [] };

const SupervisorSubSupervisorsPage = () => {
  const [banks, setBanks] = useState([]);
  const [subSupervisors, setSubSupervisors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [form, setForm] = useState(emptyForm);
  const [creating, setCreating] = useState(false);
  const [savingId, setSavingId] = useState(null);

  const load = () => {
    setLoading(true);
    setError('');
    Promise.all([listSupervisedBanks(), listSubSupervisors()])
      .then(([banksData, subsData]) => {
        setBanks(banksData);
        setSubSupervisors(subsData);
      })
      .catch(() => setError('Impossible de charger les donnees.'))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const toggleFormBank = (bankId) => {
    setForm((prev) => ({
      ...prev,
      banks: prev.banks.includes(bankId)
        ? prev.banks.filter((id) => id !== bankId)
        : [...prev.banks, bankId],
    }));
  };

  const toggleExistingBank = (sub, bankId) => {
    const newBanks = sub.banks.includes(bankId)
      ? sub.banks.filter((id) => id !== bankId)
      : [...sub.banks, bankId];
    setSubSupervisors((prev) => prev.map((s) => (s.id === sub.id ? { ...s, banks: newBanks } : s)));
  };

  const handleSaveExisting = async (sub) => {
    setSavingId(sub.id);
    setError('');
    try {
      const updated = await updateSubSupervisor(sub.id, { banks: sub.banks });
      setSubSupervisors((prev) => prev.map((s) => (s.id === sub.id ? updated : s)));
    } catch (err) {
      setError('Sauvegarde impossible.');
    } finally {
      setSavingId(null);
    }
  };

  const handleDelete = async (id) => {
    setSavingId(id);
    setError('');
    try {
      await deleteSubSupervisor(id);
      setSubSupervisors((prev) => prev.filter((s) => s.id !== id));
    } catch (err) {
      setError('Suppression impossible.');
    } finally {
      setSavingId(null);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setCreating(true);
    setError('');
    try {
      const created = await createSubSupervisor(form);
      setSubSupervisors((prev) => [...prev, created]);
      setForm(emptyForm);
    } catch (err) {
      setError('Creation impossible — verifie le username (unique) et le mot de passe.');
    } finally {
      setCreating(false);
    }
  };

  if (loading) {
    return (
      <SupervisorLayout>
        <p>Chargement...</p>
      </SupervisorLayout>
    );
  }

  return (
    <SupervisorLayout>
      <h2 className="svs-title">Sous-superviseurs</h2>

      {error && <p className="svs-error">{error}</p>}

      {subSupervisors.map((sub) => (
        <div key={sub.id} className="svs-card">
          <div className="svs-card-header">
            <span className="svs-card-title">{sub.name} ({sub.username})</span>
            <button
              type="button"
              className="svs-delete-btn"
              disabled={savingId === sub.id}
              onClick={() => handleDelete(sub.id)}
            >
              Supprimer
            </button>
          </div>
          <div className="svs-bank-list">
            {banks.map((bank) => (
              <label key={bank.id} className="svs-bank-checkbox">
                <input
                  type="checkbox"
                  checked={sub.banks.includes(bank.id)}
                  onChange={() => toggleExistingBank(sub, bank.id)}
                />
                {bank.name}
              </label>
            ))}
          </div>
          <button
            type="button"
            className="svs-save-btn"
            disabled={savingId === sub.id}
            onClick={() => handleSaveExisting(sub)}
          >
            Sauver
          </button>
        </div>
      ))}

      <div className="svs-card">
        <div className="svs-card-header">
          <span className="svs-card-title">+ Nouveau sous-superviseur</span>
        </div>
        <form onSubmit={handleCreate} className="svs-new-form">
          <div className="svs-row">
            <label className="svs-label">Nom</label>
            <input
              className="svs-input"
              type="text"
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
              required
            />
          </div>
          <div className="svs-row">
            <label className="svs-label">Username</label>
            <input
              className="svs-input"
              type="text"
              value={form.username}
              onChange={(e) => setForm((p) => ({ ...p, username: e.target.value }))}
              required
            />
          </div>
          <div className="svs-row">
            <label className="svs-label">Password</label>
            <input
              className="svs-input"
              type="password"
              value={form.password}
              onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
              required
            />
          </div>

          <div className="svs-bank-list">
            {banks.map((bank) => (
              <label key={bank.id} className="svs-bank-checkbox">
                <input
                  type="checkbox"
                  checked={form.banks.includes(bank.id)}
                  onChange={() => toggleFormBank(bank.id)}
                />
                {bank.name}
              </label>
            ))}
          </div>

          <button type="submit" className="svs-save-btn" disabled={creating}>
            {creating ? 'Creation...' : 'Creer'}
          </button>
        </form>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorSubSupervisorsPage;
